import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../lib/AuthContext'
import {
  getMisEntregas, marcarEnRuta, getDiaRepartoLabel, getFechaReparto, isAfterCutoff, yaPasoCorteD1
} from '../../lib/entregasApi'
import { supabase } from '../../lib/supabase'
import {
  geocodificar, geocodearClientesPendientes,
  ordenarPorVecinoCercano, agruparEnParadas, distanciaTotal
} from '../../lib/geo'
import QRScanner from '../../components/QRScanner'
import InstalarPWA from '../../components/InstalarPWA'

const VIVIENDA = { casa: '🏠 CASA', edificio: '🏢 EDIFICIO', oficina: '🏢 OFICINA' }

// ───────── Logos oficiales (SVG inline) ─────────
// Waze: cyan #33CCFF / WhatsApp: verde #25D366
const WAZE_CYAN = '#33CCFF'
const WAZE_CYAN_DARK = '#0793FF'
const WA_GREEN = '#25D366'
const WA_GREEN_DARK = '#1FAD52'

// Logos OFICIALES — SVG desde Simple Icons (marcas registradas, uso libre para integraciones).
// Path idéntico a simpleicons.org/icons/waze.svg y simpleicons.org/icons/whatsapp.svg
function WazeLogo({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Waze">
      <path fill="#fff" d="M20.54 6.63a9.72 9.72 0 0 1 1.09 5.66 10.15 10.15 0 0 1-.87 3.36 8.03 8.03 0 0 1-.94 1.55 8.24 8.24 0 0 1-6.03 3.14 2.6 2.6 0 0 1-.11 1 2.62 2.62 0 0 1-4.87.31 8.44 8.44 0 0 1-2.7-.66 2.62 2.62 0 0 1-4.34-1.19 2.61 2.61 0 0 1 .55-2.35 5.85 5.85 0 0 1-.6-2 6.6 6.6 0 0 1 0-1.61 1 1 0 0 1-.35-.16.94.94 0 0 1-.36-.72 1.35 1.35 0 0 1 1-1.36c.62-.2.85-.36.94-.5a1.11 1.11 0 0 0 .11-.7 8.53 8.53 0 0 1 0-2A7.87 7.87 0 0 1 5.35 4a9.55 9.55 0 0 1 6.15-2 9.72 9.72 0 0 1 6.66 2.35 9 9 0 0 1 2.38 2.28zm-1.55 1a7.11 7.11 0 0 0-2-1.94 8.14 8.14 0 0 0-5.55-2 7.75 7.75 0 0 0-5.11 1.66 6.19 6.19 0 0 0-2 3 7.83 7.83 0 0 0 0 1.66 2.72 2.72 0 0 1-.34 1.65 3.29 3.29 0 0 1-1.7 1.05 2.61 2.61 0 0 0 .77.2c.36 0 .5.09.58.14a.36.36 0 0 1 .13.29 1.9 1.9 0 0 1 0 .58 6.8 6.8 0 0 0 0 1.66 4.85 4.85 0 0 0 .75 2 .69.69 0 0 1 0 .81 1.28 1.28 0 0 0-.34 1.28A1.31 1.31 0 0 0 5 20.13a1.34 1.34 0 0 0 1-.4.7.7 0 0 1 .77-.17 7.75 7.75 0 0 0 3.4.86h.31a2.62 2.62 0 0 1 4.85 0 8.16 8.16 0 0 0 1.5-.34A7 7 0 0 0 20.4 14.7a8.7 8.7 0 0 0 .77-2.9 8.36 8.36 0 0 0-1-4.83zm-4.19 7.11a1.25 1.25 0 1 1 1.65-.63 1.25 1.25 0 0 1-1.65.63zm-6.13 0a1.25 1.25 0 1 1 1.65-.63 1.25 1.25 0 0 1-1.65.63zm7.25-4.4a3.68 3.68 0 0 0-.35-2 3.38 3.38 0 0 0-1.72-1.36.5.5 0 1 1 .38-.92 4.24 4.24 0 0 1 2.19 1.75 4.61 4.61 0 0 1 .49 2.6.5.5 0 0 1-.5.43h-.06a.5.5 0 0 1-.43-.5z"/>
    </svg>
  )
}

function WhatsAppLogo({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="WhatsApp">
      <path fill="#fff" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
    </svg>
  )
}

export default function RepartidorHoy() {
  const { user, profile } = useAuth()
  const nombreRepartidor = profile?.nombre?.split(' ')[0] || 'tu repartidor'
  const navigate = useNavigate()
  const [fecha, setFecha] = useState(getFechaReparto())
  const [entregas, setEntregas] = useState([])
  const [deposito, setDeposito] = useState(null)
  const [loading, setLoading] = useState(true)
  const [optimizando, setOptimizando] = useState(false)
  // 'en_ruta' = lo que tengo en la camioneta AHORA (default)
  // 'proximas' = asignadas pero todavia no cargue
  // 'hechas' = entregadas o no entregadas
  // 'todas' = todo
  const [filtro, setFiltro] = useState('en_ruta')
  const [enviando, setEnviando] = useState(false)
  const [showDeposito, setShowDeposito] = useState(false)
  const [showScanner, setShowScanner] = useState(false)
  const [scanError, setScanError] = useState(null)
  const [aviso, setAviso] = useState(null)
  const [confirmSalir, setConfirmSalir] = useState(false)

  useEffect(() => {
    if (!user?.id) return
    cargarTodo()
  }, [user?.id, fecha])

  async function cargarTodo() {
    setLoading(true)
    const [{ data: dep }, ents] = await Promise.all([
      supabase.rpc('get_deposito'),
      getMisEntregas(user.id, fecha),
    ])
    const depo = dep?.[0]?.lat ? dep[0] : null
    setDeposito(depo)
    setEntregas(ents)
    setLoading(false)
    if (!depo) setShowDeposito(true)
  }

  async function optimizar() {
    if (!deposito?.lat) { setShowDeposito(true); return }
    const pendientes = entregas.filter(e => e.estado === 'programada' || e.estado === 'en_ruta')
    const sinGeo = pendientes.filter(e => !e.cliente?.lat)
    if (sinGeo.length === 0) return
    setOptimizando(true)
    try {
      const clientesUnicos = [...new Map(sinGeo.map(e => [e.cliente.id, e.cliente])).values()]
      await geocodearClientesPendientes(clientesUnicos)
      await cargarTodo()
    } finally { setOptimizando(false) }
  }

  async function salirARuta() {
    const programadas = entregas.filter(e => e.estado === 'programada').map(e => e.id)
    if (programadas.length === 0) return
    setEnviando(true)
    try {
      // Construir orden a partir de las paradas optimizadas por vecino-cercano.
      // Si hay programadas que no aparecen en paradas (sin geo) las dejamos al final.
      const orden = []
      const enParadas = new Set()
      for (const p of paradas) {
        for (const e of p.entregas) {
          if (e.estado === 'programada') { orden.push(e.id); enParadas.add(e.id) }
        }
      }
      for (const id of programadas) if (!enParadas.has(id)) orden.push(id)

      const { data, error } = await supabase.rpc('repartidor_salir_ruta', { p_entregas_ordenadas: orden })
      if (error) throw error
      if (data?.aviso_encolado) {
        // El primer cliente ya tiene su aviso encolado. Nada más que hacer.
      }
      await cargarTodo()
    } catch (e) { setAviso('No se pudo salir a ruta. Revisá la conexión y reintentá.') }
    finally { setEnviando(false) }
  }

  async function logout() {
    await supabase.auth.signOut()
    navigate('/login', { replace: true })
  }

  /** Procesa un QR escaneado: valida que sea una entrega tuya y navega al flujo de confirmación. */
  function onQRDetectado(text) {
    setShowScanner(false)
    setScanError(null)
    // Esperamos algo tipo https://limpack.uy/d/XXXXXX o /d/XXXXXX
    const match = String(text).match(/\/d\/([a-zA-Z0-9_-]+)/)
    if (!match) {
      setScanError('❌ Ese QR no es de una etiqueta Limpack.')
      setTimeout(() => setScanError(null), 5000)
      return
    }
    const token = match[1]
    const e = entregas.find(x => x.tracking_token === token)

    // 1. La entrega no está en MI ruta del día → bloquear (seguridad operativa)
    if (!e) {
      setScanError('⚠️ Esta entrega no está en tu ruta de hoy. Pedí a admin que te la asigne o revisá si es la etiqueta correcta.')
      setTimeout(() => setScanError(null), 6000)
      return
    }
    // 2. Ya entregada → avisar
    if (e.estado === 'entregada') {
      setScanError(`✅ ${(e.cliente?.beneficiario || e.cliente?.titular)?.nombre || 'Esta entrega'} ya está marcada como entregada.`)
      setTimeout(() => setScanError(null), 5000)
      return
    }
    // 3. Cancelada → avisar
    if (e.estado === 'cancelada') {
      setScanError('⚠️ Esta entrega fue cancelada. No corresponde entregarla.')
      setTimeout(() => setScanError(null), 5000)
      return
    }
    // OK: es mía y está pendiente → al flujo de confirmación
    navigate(`/d/${token}`)
  }

  // Filtrado + ordenamiento por ruta + agrupación en paradas
  const paradas = useMemo(() => {
    const filtradas =
      filtro === 'en_ruta'  ? entregas.filter(e => e.estado === 'en_ruta')
    : filtro === 'proximas' ? entregas.filter(e => e.estado === 'programada')
    : filtro === 'hechas'   ? entregas.filter(e => e.estado === 'entregada' || e.estado === 'no_entregada')
    :                          entregas
    // Anotar lat/lng del cliente en la entrega para los helpers
    const conGeo = filtradas.map(e => ({ ...e, lat: e.cliente?.lat, lng: e.cliente?.lng }))
    if (!deposito?.lat) {
      // Sin depósito → orden por ventana + barrio (orden natural del query)
      return [{ centroide: { lat: null, lng: null }, entregas: conGeo, label: '', numero: 1, distanciaDesdeAnterior: null }]
    }
    const ordenadas = ordenarPorVecinoCercano(deposito, conGeo)
    return agruparEnParadas(ordenadas, 80)
  }, [entregas, filtro, deposito])

  const counts = useMemo(() => ({
    enRuta:   entregas.filter(e => e.estado === 'en_ruta').length,
    proximas: entregas.filter(e => e.estado === 'programada').length,
    hechas:   entregas.filter(e => e.estado === 'entregada' || e.estado === 'no_entregada').length,
    todas:    entregas.length,
  }), [entregas])

  const programadasCount = counts.proximas
  const after = isAfterCutoff()

  // Próxima parada que tenga al menos una entrega activa (solo aplica al tab "En ruta")
  const proximaParada = useMemo(() => {
    if (filtro !== 'en_ruta') return null
    return paradas.find(p => p.entregas.some(e => e.estado === 'en_ruta'))
  }, [paradas, filtro])

  // Geo necesita refresco? (programadas y en_ruta van a necesitar lat/lng)
  const sinGeoCount = entregas.filter(e =>
    (e.estado === 'programada' || e.estado === 'en_ruta') && !e.cliente?.lat
  ).length

  // IDs de entregas que ya fueron anunciadas via repartidor_anunciar_proxima
  // (para mostrar el botón como ya-disparado sin permitir doble click).
  const [anunciadas, setAnunciadas] = useState(new Set())
  useEffect(() => {
    const ids = entregas.map(e => e.id)
    if (ids.length === 0) return
    supabase.from('automatizaciones_log')
      .select('origen_id')
      .eq('tipo', 'repartidor_saliendo')
      .in('origen_id', ids)
      .then(({ data }) => {
        if (data) setAnunciadas(new Set(data.map(r => r.origen_id)))
      })
  }, [entregas.length])

  // Llama RPC repartidor_anunciar_proxima → dispara template Meta al cliente.
  async function anunciarProxima(entregaId) {
    try {
      const { data, error } = await supabase.rpc('repartidor_anunciar_proxima', { p_entrega_id: entregaId })
      if (error) { alert('No se pudo avisar: ' + error.message); return }
      if (!data?.ok && data?.razon === 'ya_anunciada') {
        alert('Ya se avisó a este cliente — el mensaje salió antes.')
      }
      setAnunciadas(prev => new Set([...prev, entregaId]))
    } catch (e) {
      alert('Error: ' + (e.message || e))
    }
  }

  return (
    <div className="rep-app">
      <header className="rep-head">
        <div>
          <div className="rep-brand">Limpack</div>
          <div className="rep-sub">Hola, <strong>{nombreRepartidor}</strong></div>
        </div>
        <button className="rep-logout" onClick={logout}>Salir</button>
      </header>

      {/* Prompt para instalar como app — se oculta solo si ya está instalado o fue descartado */}
      <div style={{ padding: '0 12px' }}>
        <InstalarPWA texto="Acceso directo en la pantalla de inicio, ruta del día al toque" />
      </div>

      <div className="rep-fecha">
        <div className="rep-fecha-label">{after ? '🔒 Mañana' : '📦 Hoy'} — {getDiaRepartoLabel()}</div>
        <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} className="rep-fecha-input" />
      </div>

      {/* Banda de configuración del depósito */}
      {!deposito?.lat && (
        <div className="rep-warn-bar" onClick={() => setShowDeposito(true)}>
          ⚠️ Configurá tu punto de partida para optimizar la ruta →
        </div>
      )}
      {deposito?.lat && sinGeoCount > 0 && (
        <div className="rep-info-bar">
          📍 {sinGeoCount} dirección{sinGeoCount !== 1 ? 'es' : ''} sin ubicar
          <button className="rep-link-btn" onClick={optimizar} disabled={optimizando}>
            {optimizando ? 'Buscando…' : 'Geocodear y optimizar →'}
          </button>
        </div>
      )}

      <div className="rep-tabs">
        <button className={`rep-tab ${filtro === 'en_ruta' ? 'active' : ''}`} onClick={() => setFiltro('en_ruta')}>
          En ruta <span className="rep-tab-num">{counts.enRuta}</span>
        </button>
        <button className={`rep-tab ${filtro === 'proximas' ? 'active' : ''}`} onClick={() => setFiltro('proximas')}>
          Próximas <span className="rep-tab-num">{counts.proximas}</span>
        </button>
        <button className={`rep-tab ${filtro === 'hechas' ? 'active' : ''}`} onClick={() => setFiltro('hechas')}>
          Hechas <span className="rep-tab-num">{counts.hechas}</span>
        </button>
        <button className={`rep-tab ${filtro === 'todas' ? 'active' : ''}`} onClick={() => setFiltro('todas')}>
          Todas <span className="rep-tab-num">{counts.todas}</span>
        </button>
      </div>

      {/* Botón salir a ruta — Fix #25: solo habilitado si corte D-1 pasó Y todas tienen pago vinculado */}
      {programadasCount > 0 && filtro !== 'hechas' && (() => {
        const programadas = entregas.filter(e => e.estado === 'programada')
        const cortePaso = programadas.every(e => yaPasoCorteD1(e.fecha_programada))
        const todasConPago = programadas.every(e => !!e.pago_id)
        const razonBloqueo = !cortePaso
          ? '🔒 Esperar corte D-1 16hs'
          : !todasConPago
            ? '⚠ Alguna entrega sin pago confirmado'
            : null
        const disabled = enviando || !!razonBloqueo
        return (
          <div className="rep-action-bar">
            <button
              className="rep-btn-ruta"
              onClick={() => setConfirmSalir(true)}
              disabled={disabled}
              title={razonBloqueo || 'Salir a ruta'}
              style={razonBloqueo ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
            >
              {razonBloqueo ? `🔒 ${razonBloqueo.replace(/^[🔒⚠]\s*/, '')}` : `🚐 Salir a ruta (${programadasCount})`}
            </button>
          </div>
        )
      })()}

      {/* HERO: próxima parada */}
      {proximaParada && (
        <ProximaParadaCard parada={proximaParada} deposito={deposito} navigate={navigate} nombreRepartidor={nombreRepartidor} anunciarProxima={anunciarProxima} anunciadas={anunciadas} />
      )}

      {/* Lista de todas las paradas */}
      {loading ? (
        <div className="rep-empty">Cargando…</div>
      ) : paradas.length === 0 || (paradas.length === 1 && paradas[0].entregas.length === 0) ? (
        <div className="rep-empty">
          {filtro === 'en_ruta' && (programadasCount > 0
            ? '📦 Cargá tu camioneta y tocá "Salir a ruta" arriba.'
            : '🎉 No tenés entregas en ruta. ¡Buen trabajo!')}
          {filtro === 'proximas' && 'No tenés próximas asignadas para esta fecha.'}
          {filtro === 'hechas' && 'Todavía no hiciste ninguna.'}
          {filtro === 'todas' && 'No tenés entregas asignadas para esta fecha.'}
        </div>
      ) : (
        <div className="rep-list">
          <div className="rep-list-title">
            🗺️ Ruta · {paradas.filter(p => p.entregas.length > 0).length} parada{paradas.length !== 1 ? 's' : ''}
          </div>
          {paradas.map((p) => (
            <ParadaCard
              key={p.numero}
              parada={p}
              esProxima={proximaParada && proximaParada.numero === p.numero}
              navigate={navigate}
              nombreRepartidor={nombreRepartidor}
              anunciarProxima={anunciarProxima}
              anunciadas={anunciadas}
            />
          ))}
        </div>
      )}

      {showDeposito && (
        <DepositoModal
          actual={deposito}
          onClose={() => setShowDeposito(false)}
          onSaved={async () => { setShowDeposito(false); await cargarTodo() }}
        />
      )}

      {showScanner && (
        <QRScanner
          onDetect={onQRDetectado}
          onClose={() => setShowScanner(false)}
        />
      )}

      {/* Toast de error del scanner */}
      {scanError && (
        <div className="rep-toast">{scanError}</div>
      )}
      {aviso && (
        <div className="rep-toast" onClick={() => setAviso(null)}>{aviso}</div>
      )}
      {confirmSalir && (
        <div onClick={() => setConfirmSalir(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(10,20,36,.6)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 20, width: '100%', maxWidth: 420, boxShadow: '0 -4px 24px rgba(0,0,0,.25)' }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#1A3461', marginBottom: 8 }}>¿Salir a ruta?</div>
            <div style={{ fontSize: 14, color: '#475569', lineHeight: 1.5, marginBottom: 18 }}>
              Vas a salir con <strong>{programadasCount}</strong> entrega{programadasCount !== 1 ? 's' : ''}. Se le avisa al primer cliente al toque, y a los demás cuando marques "Entregado" en la parada anterior.
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setConfirmSalir(false)} style={{ flex: 1, minHeight: 52, borderRadius: 12, border: '1px solid #CBD5E1', background: '#fff', color: '#334155', fontWeight: 800, fontSize: 15, cursor: 'pointer' }}>Cancelar</button>
              <button onClick={() => { setConfirmSalir(false); salirARuta() }} disabled={enviando} style={{ flex: 2, minHeight: 52, borderRadius: 12, border: 0, background: '#00A8B5', color: '#fff', fontWeight: 900, fontSize: 15, cursor: 'pointer' }}>🚐 Salir a ruta</button>
            </div>
          </div>
        </div>
      )}

      {/* Botón flotante para escanear QR (FAB) */}
      <button
        className="rep-fab-scan"
        onClick={() => setShowScanner(true)}
        aria-label="Escanear QR"
      >
        📷 <span>Escanear QR</span>
      </button>

      <style>{styles}</style>
    </div>
  )
}

/* ───────── Próxima parada (HERO destacado arriba) ───────── */
function ProximaParadaCard({ parada, navigate, nombreRepartidor, anunciarProxima, anunciadas }) {
  const pendientes = parada.entregas.filter(e => e.estado === 'programada' || e.estado === 'en_ruta')
  if (pendientes.length === 0) return null
  const dirRef = pendientes[0].cliente
  // FIX 14-sep-2026: Waze recibe SOLO la dirección limpia (calle + Montevideo + Uruguay).
  // Antes se anexaba el barrio (ej "CAPURRO BELLA VISTA") y Waze desviaba la búsqueda
  // varias cuadras. Nominatim en UY geocodifica mal → nunca navegar por coordenada guardada.
  const wazeQuery = (dirRef?.direccion || '').trim()
  const wazeUrl = wazeQuery
    ? `https://www.waze.com/ul?q=${encodeURIComponent(`${wazeQuery}, Montevideo, Uruguay`)}&navigate=yes`
    : `https://www.waze.com/ul?ll=${parada.centroide.lat}%2C${parada.centroide.lng}&navigate=yes`
  const km = parada.distanciaDesdeAnterior ? (parada.distanciaDesdeAnterior / 1000).toFixed(1) : null

  // WA al primer cliente de la parada (si son varios, abre uno por uno)
  const cliente0 = pendientes[0]?.cliente
  const recibe0 = cliente0?.beneficiario || cliente0?.titular
  const tel0Raw = (recibe0?.phone || '').replace(/[^\d]/g, '')
  const tel0Wa = tel0Raw ? (tel0Raw.startsWith('598') ? tel0Raw : '598' + tel0Raw.replace(/^0+/, '')) : null
  const nombre0 = recibe0?.nombre?.split(' ')[0] || ''
  const waMsg0 = encodeURIComponent(
    `Hola ${nombre0}! Soy ${nombreRepartidor || 'tu repartidor'} de *Limpack*. Estoy yendo con tu pedido, llego en unos minutos.`
  )
  const waUrl0 = tel0Wa ? `https://wa.me/${tel0Wa}?text=${waMsg0}` : null

  // Token de la primera entrega para "Entregado" (ir a confirmar)
  const tokenEntregar = pendientes[0]?.tracking_token

  // Datos del cliente para mostrar arriba
  const nombreClienteParada = recibe0?.nombre || ''
  const direccionParada = `${cliente0?.direccion || ''}${cliente0?.apto ? ` · ${cliente0.apto}` : ''}`

  // Identificador del paquete: últimos 3 dígitos del numero_orden + total de bultos
  // Si hay varias entregas en la parada, mostramos todos
  return (
    <div className="rep-prox">
      <div className="rep-prox-tag">PRÓXIMA ENTREGA</div>

      {/* Strip de IDs de paquetes — bien visible para que el repartidor agarre el bulto correcto */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
        {pendientes.map(e => {
          const idCorto = (e.numero_orden || '').split('-').pop() || '?'
          return (
            <div key={e.id} style={{
              background: '#fff', color: '#1A3461',
              padding: '8px 14px', borderRadius: 10,
              fontWeight: 900, fontSize: 18, letterSpacing: '.04em',
              display: 'flex', alignItems: 'center', gap: 8,
              border: '2px solid rgba(255,255,255,.4)',
            }}>
              <span style={{ fontSize: 11, color: '#64748b', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase' }}>PAQUETE</span>
              <span>#{idCorto}</span>
              <span style={{
                background: '#0EA5E9', color: '#fff',
                padding: '2px 8px', borderRadius: 999,
                fontSize: 11, fontWeight: 800,
              }}>
                {e.bultos_total || 1} {(e.bultos_total || 1) === 1 ? 'bulto' : 'bultos'}
              </span>
            </div>
          )
        })}
      </div>

      <div className="rep-prox-head">
        <div className="rep-prox-bnum">{parada.entregas.length}</div>
        <div>
          <div className="rep-prox-titulo">{nombreClienteParada}</div>
          <div className="rep-prox-barrio">{direccionParada}</div>
          <div className="rep-prox-km" style={{ marginTop: 4 }}>
            {parada.label}{km ? ` · 📍 a ~${km} km` : ''}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
        <a href={wazeUrl} target="_blank" rel="noopener" className="rep-btn-ir"
           style={{ background: WAZE_CYAN, color: '#fff', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, minHeight: 56, boxShadow: '0 2px 6px rgba(51,204,255,.35)' }}>
          <WazeLogo size={26} />
          <span>IR CON WAZE</span>
        </a>
        {waUrl0 && (
          <a href={waUrl0} target="_blank" rel="noopener" className="rep-btn-ir"
             style={{ background: WA_GREEN, color: '#fff', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, minHeight: 56, boxShadow: `0 2px 6px ${WA_GREEN}55`, fontWeight: 800, textDecoration: 'none' }}>
            <WhatsAppLogo size={26} /><span>AVISAR QUE VOY</span>
          </a>
        )}
        {tokenEntregar && (
          <button onClick={() => navigate(`/d/${tokenEntregar}`)}
            className="rep-btn-ir"
            style={{ background: '#10B981', color: '#fff', border: 0, cursor: 'pointer', fontFamily: 'inherit', minHeight: 56, fontSize: 15, fontWeight: 800 }}>
            ✓ MARCAR ENTREGADO
          </button>
        )}
      </div>
    </div>
  )
}

/* ───────── Parada (puede tener N entregas) ─────────
   Diseño: header del CLIENTE arriba (una sola vez, aunque tenga N entregas)
   + botones de acción agrupados (Waze + WhatsApp)
   + lista compacta de entregas debajo (cada una con su botón Entregar). */
function ParadaCard({ parada, esProxima, navigate, nombreRepartidor, anunciarProxima, anunciadas }) {
  if (parada.entregas.length === 0) return null
  const múltiple = parada.entregas.length > 1
  const e0 = parada.entregas[0]
  const cli = e0.cliente
  const recibe = cli?.beneficiario || cli?.titular
  const titular = cli?.titular
  const esRegalo = cli?.beneficiario && cli?.beneficiario?.id !== cli?.titular?.id
  const bultosTotales = parada.entregas.reduce((acc, e) => acc + (e.bultos_total || 1), 0)

  // Waze: SOLO la dirección limpia (calle + Montevideo + Uruguay), sin barrio.
  // Fix 14-sep-2026 tras reporte de Nico (Agraciada, 3 cuadras): el barrio anexado
  // desviaba la búsqueda. Nominatim UY geocodifica mal → nunca navegar por coordenada.
  const wazeQuery = (cli?.direccion || '').trim()
  const wazeUrl = wazeQuery
    ? `https://www.waze.com/ul?q=${encodeURIComponent(`${wazeQuery}, Montevideo, Uruguay`)}&navigate=yes`
    : `https://www.waze.com/ul?ll=${parada.centroide.lat}%2C${parada.centroide.lng}&navigate=yes`

  // WhatsApp al receptor (mismo tel para todas las entregas, son del mismo cliente)
  const telRaw = (recibe?.phone || '').replace(/[^\d]/g, '')
  const telWa = telRaw ? (telRaw.startsWith('598') ? telRaw : '598' + telRaw.replace(/^0+/, '')) : null
  const nombreCli = recibe?.nombre?.split(' ')[0] || ''
  // Unificado con waMsg0 (línea 302) — antes había 2 variantes para el
  // mismo escenario "repartidor llegando". Auditoría WA 2026-06-04.
  const waMsg = encodeURIComponent(
    `Hola ${nombreCli}! Soy ${nombreRepartidor || 'tu repartidor'} de *Limpack*. Estoy yendo con tu pedido, llego en unos minutos.`
  )
  const waUrl = telWa ? `https://wa.me/${telWa}?text=${waMsg}` : null

  const km = parada.distanciaDesdeAnterior ? (parada.distanciaDesdeAnterior / 1000).toFixed(1) : null

  return (
    <div className={`rep-parada ${esProxima ? 'es-prox' : ''} ${múltiple ? 'multi' : ''}`}>
      {/* HEADER del cliente (una sola vez) */}
      <div className="rep-parada-head">
        <div className="rep-parada-num">P{parada.numero}</div>
        <div className="rep-parada-info">
          <div className="rep-parada-nombre">{recibe?.nombre || '—'}</div>
          {cli?.alias && (
            <div className="rep-parada-alias">📍 {cli.alias.toUpperCase()}</div>
          )}
          <div className="rep-parada-dir">
            {cli?.direccion}{cli?.apto ? ` · ${cli.apto}` : ''}
            {parada.label && <> · {parada.label}</>}
            {cli?.tipo_vivienda && <span className="rep-parada-viv">{VIVIENDA[cli.tipo_vivienda]}</span>}
          </div>
          {esRegalo && (
            <div className="rep-parada-regalo">🎁 Contrata: {titular?.nombre}</div>
          )}
        </div>
        <div className="rep-parada-bultos">
          <div className="rep-bnum">{bultosTotales}</div>
          <div className="rep-blab">{bultosTotales === 1 ? 'BULTO' : 'BULTOS'}</div>
        </div>
      </div>

      {km && <div className="rep-parada-km">📍 a ~{km} km del punto anterior</div>}

      {/* BOTONES DE ACCIÓN agrupados — colores oficiales Waze (cyan) y WhatsApp (verde) */}
      <div className="rep-parada-acciones">
        <a href={wazeUrl} target="_blank" rel="noopener" className="rep-btn rep-btn-waze"
           style={{ background: WAZE_CYAN, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, minHeight: 50 }}>
          <WazeLogo size={22} />
          <span>WAZE</span>
        </a>
        {(() => {
          const enRutaId = parada.entregas.find(e => e.estado === 'en_ruta')?.id
          if (!enRutaId || !waUrl) return null
          return (
            <a href={waUrl} target="_blank" rel="noopener" className="rep-btn rep-btn-wa"
               style={{ background: WA_GREEN, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, minHeight: 50, border: 0, textDecoration: 'none' }}>
              <WhatsAppLogo size={22} /><span>AVISAR</span>
            </a>
          )
        })()}
      </div>

      {/* LISTA de entregas (compacta) */}
      <div className="rep-parada-body">
        {parada.entregas.map((e) => (
          <EntregaRow key={e.id} e={e} navigate={navigate} />
        ))}
      </div>
    </div>
  )
}

/* ───────── Row compacto de una entrega (sin repetir cliente) ───────── */
function EntregaRow({ e, navigate }) {
  const [verItems, setVerItems] = useState(false)
  const [chequeados, setChequeados] = useState({}) // { idx: true }
  const yaHecha = e.estado === 'entregada' || e.estado === 'no_entregada' || e.estado === 'cancelada'
  const numCorto = (e.numero_orden || '').split('-').pop() || '?'
  const items = Array.isArray(e.pedido_items) ? e.pedido_items : []
  const totalItems = items.length
  const cantChequeados = Object.values(chequeados).filter(Boolean).length
  const listoParaSalir = totalItems > 0 && cantChequeados === totalItems

  const estadoCfg = {
    programada:   { label: 'PEND.',     color: '#0EA5E9', bg: '#E0F2FE' },
    en_ruta:      { label: 'EN RUTA',   color: '#92400E', bg: '#FEF3C7' },
    entregada:    { label: 'ENTREGADA', color: '#065F46', bg: '#D1FAE5' },
    no_entregada: { label: 'NO ENT.',   color: '#991B1B', bg: '#FEE2E2' },
    cancelada:    { label: 'CANCEL.',   color: '#475569', bg: '#F1F5F9' },
  }
  const cfg = estadoCfg[e.estado] || estadoCfg.programada

  function toggleItem(i) {
    setChequeados(c => ({ ...c, [i]: !c[i] }))
  }

  return (
    <div className={`rep-ent-row2 ${yaHecha ? 'hecha' : ''}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#1A3461', color: '#fff', borderRadius: 10, padding: '4px 12px', minWidth: 64, lineHeight: 1 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.12em', opacity: .75 }}>PAQUETE</span>
          <span style={{ fontSize: 26, fontWeight: 900, letterSpacing: '-.02em' }}>#{numCorto}</span>
        </div>
        <div className="rep-ent-meta-row" style={{ flex: 1, minWidth: 0 }}>
          <span className="rep-ent-kit2">{e.kit?.nombre || 'Kit'}</span>
          <span className="rep-ent-mini-bultos">{e.bultos_total || 1}B</span>
          <span className="rep-pill" style={{ background: cfg.bg, color: cfg.color }}>● {cfg.label}</span>
        </div>
      </div>

      {e.notas && (
        <div className="rep-notas-mini" title={e.notas}>{e.notas}</div>
      )}

      {/* Contenido del pedido — accordion para chequear al armar bulto */}
      {totalItems > 0 && !yaHecha && (
        <div style={{ marginTop: 8 }}>
          <button
            onClick={() => setVerItems(v => !v)}
            style={{
              width: '100%',
              padding: '8px 10px',
              background: listoParaSalir ? '#D1FAE5' : (verItems ? '#F1F5F9' : 'white'),
              border: `1px solid ${listoParaSalir ? '#10B981' : '#CBD5E1'}`,
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 700,
              color: listoParaSalir ? '#065F46' : '#334155',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <span>
              {listoParaSalir ? '✅' : '📦'} Contenido del pedido ({cantChequeados}/{totalItems})
            </span>
            <span style={{ fontSize: 11, opacity: 0.7 }}>{verItems ? '▲' : '▼'}</span>
          </button>
          {verItems && (
            <ul style={{ listStyle: 'none', padding: '10px 8px 6px', margin: 0, background: '#FAFAF9', border: '1px solid #E5E7EB', borderTop: 0, borderRadius: '0 0 6px 6px' }}>
              {items.map((it, i) => {
                const done = !!chequeados[i]
                return (
                  <li key={i} onClick={() => toggleItem(i)} style={{
                    display: 'flex', alignItems: 'flex-start', gap: 8,
                    padding: '7px 4px', borderBottom: i < items.length - 1 ? '1px solid #F3F4F6' : 'none',
                    cursor: 'pointer', userSelect: 'none',
                  }}>
                    <input
                      type="checkbox"
                      checked={done}
                      onChange={() => toggleItem(i)}
                      onClick={(ev) => ev.stopPropagation()}
                      style={{ marginTop: 2, cursor: 'pointer', width: 18, height: 18, flexShrink: 0 }}
                    />
                    <div style={{ flex: 1, minWidth: 0, fontSize: 13, lineHeight: 1.35, color: done ? '#94A3B8' : '#1E293B', textDecoration: done ? 'line-through' : 'none' }}>
                      <strong style={{ color: done ? '#94A3B8' : '#1A3461', marginRight: 6 }}>
                        {it.cantidad}×
                      </strong>
                      {it.descripcion || 'Producto'}
                      {it.es_regalo && (
                        <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, background: '#FEF3C7', color: '#92400E', padding: '1px 5px', borderRadius: 3, verticalAlign: 'middle' }}>🎁 regalo</span>
                      )}
                      {it.tipo === 'extra' && (
                        <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, background: '#DBEAFE', color: '#1E40AF', padding: '1px 5px', borderRadius: 3, verticalAlign: 'middle' }}>+ extra</span>
                      )}
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}

      {!yaHecha && (
        <button className="rep-btn rep-btn-ok" onClick={() => navigate(`/d/${e.tracking_token}`)}>
          📋 Cerrar entrega
        </button>
      )}
    </div>
  )
}

/* ───────── Modal configurar depósito (geocoding inline) ───────── */
function DepositoModal({ actual, onClose, onSaved }) {
  const [direccion, setDireccion] = useState(actual?.direccion || '')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  async function guardar() {
    setErr(null); setBusy(true)
    try {
      const geo = await geocodificar(direccion)
      if (!geo) throw new Error('No pude encontrar esa dirección. Probá con calle + número + barrio.')
      const { error } = await supabase.rpc('set_deposito', { direccion_p: direccion, lat_p: geo.lat, lng_p: geo.lng })
      if (error) throw error
      onSaved()
    } catch (e) { setErr(e.message) }
    finally { setBusy(false) }
  }

  return (
    <div className="rep-modal-bg" onClick={onClose}>
      <div className="rep-modal" onClick={ev => ev.stopPropagation()}>
        <h2 style={{ margin: '0 0 4px' }}>📍 Punto de partida</h2>
        <p style={{ fontSize: 13, color: '#666', marginTop: 0 }}>
          Tu casa o depósito de donde salís a hacer las entregas. Sirve para optimizar la ruta.
        </p>
        <input
          type="text"
          value={direccion}
          onChange={ev => setDireccion(ev.target.value)}
          placeholder="Ej: Av. Italia 1234, Pocitos"
          style={{ width: '100%', padding: 12, fontSize: 15, borderRadius: 8, border: '1px solid #ccc' }}
        />
        {err && <div style={{ color: '#991B1B', fontSize: 13, marginTop: 8 }}>{err}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 14, justifyContent: 'flex-end' }}>
          <button onClick={onClose} className="btn ghost">Cancelar</button>
          <button onClick={guardar} disabled={busy || !direccion.trim()} className="btn primary">
            {busy ? 'Buscando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  )
}

const styles = `
:root {
  --rep-pri: #1A3461;
  --rep-acc: #00A8B5;
  --rep-warn: #F59E0B;
  --rep-bg: #F4F5F7;
  --rep-card: #fff;
  --rep-line: #E5E7EB;
  --rep-mut: #6B7280;
}
body { background: var(--rep-bg); margin: 0; font-family: 'Inter', sans-serif; }
.rep-app { max-width: 480px; margin: 0 auto; padding-bottom: 100px; color: #111 }
.rep-head {
  position: sticky; top: 0; z-index: 10;
  background: var(--rep-pri); color: #fff;
  padding: 14px 16px;
  display: flex; justify-content: space-between; align-items: center;
}
.rep-brand { font-size: 18px; font-weight: 900; letter-spacing: -.02em }
.rep-sub { font-size: 12px; opacity: .8; margin-top: 2px }
.rep-logout { background: rgba(255,255,255,.15); color: #fff; border: 0; padding: 8px 14px; border-radius: 8px; font-size: 13px; font-weight: 600 }
.rep-fecha { background: #fff; padding: 12px 16px; border-bottom: 1px solid var(--rep-line); display: flex; justify-content: space-between; align-items: center; gap: 10px }
.rep-fecha-label { font-size: 13px; font-weight: 700; color: var(--rep-pri) }
.rep-fecha-input { font-size: 13px; padding: 6px 10px; border: 1px solid var(--rep-line); border-radius: 6px; background: #fff; font-family: inherit }
.rep-warn-bar { background: #FEF3C7; color: #92400E; padding: 10px 16px; font-size: 13px; font-weight: 600; cursor: pointer; border-bottom: 1px solid #F59E0B }
.rep-info-bar { background: #E0F2FE; color: #0C4A6E; padding: 10px 16px; font-size: 13px; display: flex; justify-content: space-between; align-items: center; gap: 8px; border-bottom: 1px solid #0EA5E9 }
.rep-link-btn { background: transparent; border: 0; color: #0C4A6E; text-decoration: underline; font-weight: 700; font-size: 13px; cursor: pointer; padding: 0 }
.rep-link-btn:disabled { opacity: .5 }
.rep-tabs { background: #fff; padding: 6px; border-bottom: 1px solid var(--rep-line); display: flex; gap: 4px }
.rep-tab { flex: 1; background: transparent; border: 0; padding: 10px 4px; border-radius: 8px; font-size: 13px; font-weight: 700; color: var(--rep-mut); cursor: pointer; display: flex; flex-direction: column; align-items: center; gap: 2px }
.rep-tab.active { background: var(--rep-pri); color: #fff }
.rep-tab-num { font-size: 16px; font-weight: 900 }
.rep-action-bar { background: var(--rep-bg); padding: 10px 12px }
.rep-btn-ruta { width: 100%; background: var(--rep-pri); color: #fff; border: 0; padding: 14px; border-radius: 10px; font-size: 14px; font-weight: 800; box-shadow: 0 4px 12px rgba(15,31,61,.25); cursor: pointer }
.rep-btn-ruta:disabled { opacity: .5 }
.rep-empty { text-align: center; padding: 60px 20px; color: var(--rep-mut); font-size: 14px }

/* HERO próxima parada */
.rep-prox {
  margin: 12px;
  background: linear-gradient(135deg, #00A8B5 0%, #1A3461 100%);
  color: #fff; border-radius: 16px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 168, 181, .25);
}
.rep-prox-tag { font-size: 11px; font-weight: 800; letter-spacing: .15em; opacity: .8; margin-bottom: 6px }
.rep-prox-head { display: flex; align-items: center; gap: 14px; margin-bottom: 14px }
.rep-prox-bnum {
  font-size: 38px; font-weight: 900; line-height: 1;
  background: rgba(255,255,255,.2); padding: 8px 16px; border-radius: 12px;
  letter-spacing: -.05em;
}
.rep-prox-titulo { font-size: 17px; font-weight: 800; line-height: 1.15 }
.rep-prox-barrio { font-size: 13px; opacity: .9; margin-top: 2px; text-transform: uppercase; letter-spacing: .08em; font-weight: 700 }
.rep-prox-km { font-size: 12px; opacity: .85; margin-top: 4px }
.rep-btn-ir {
  display: block; width: 100%; box-sizing: border-box;
  background: #33CCFF; color: #002B4D;
  text-align: center; text-decoration: none;
  padding: 16px; border-radius: 12px;
  font-size: 17px; font-weight: 900; letter-spacing: .05em;
  box-shadow: 0 4px 16px rgba(51,204,255,.5);
}

/* Lista de paradas */
.rep-list { padding: 12px; display: flex; flex-direction: column; gap: 10px }
.rep-list-title { font-size: 12px; font-weight: 800; color: var(--rep-mut); text-transform: uppercase; letter-spacing: .12em; padding: 4px 4px 0 }
.rep-parada {
  background: var(--rep-card); border-radius: 14px;
  padding: 12px; box-shadow: 0 1px 3px rgba(0,0,0,.06);
  border: 2px solid transparent;
}
.rep-parada.es-prox { border-color: var(--rep-acc); display: none } /* Si está como hero arriba, no la repetimos abajo */
.rep-parada.multi { background: linear-gradient(180deg, #fff 0%, #F0F9FF 100%); border-color: #0EA5E9 }
.rep-parada-head {
  display: grid; grid-template-columns: auto 1fr auto;
  gap: 10px; align-items: flex-start; margin-bottom: 8px;
}
.rep-parada-num {
  font-size: 14px; font-weight: 900;
  background: var(--rep-pri); color: #fff;
  padding: 6px 10px; border-radius: 8px;
  letter-spacing: -.02em;
  align-self: flex-start;
}
.rep-parada-info { min-width: 0 }
.rep-parada-titulo { font-size: 14px; font-weight: 800; line-height: 1.15 } /* legacy, no se usa más */
.rep-parada-barrio { color: var(--rep-mut); font-weight: 600 } /* legacy */
.rep-parada-km {
  font-size: 11px; color: var(--rep-mut);
  margin: 4px 0 0; padding: 4px 8px;
  background: #f1f5f9; border-radius: 4px; display: inline-block;
}
.rep-parada-waze {
  display: inline-flex; align-items: center; justify-content: center;
  width: 42px; height: 42px;
  background: #33CCFF; color: #002B4D; text-decoration: none;
  border-radius: 10px; font-size: 22px;
}
/* ── HEADER del cliente dentro de la parada ── */
.rep-parada-nombre { font-size: 16px; font-weight: 800; line-height: 1.2; color: #1A3461 }
.rep-parada-alias { font-size: 10px; font-weight: 800; color: #1A3461; margin-top: 2px; letterletter-spacing: .05em }
.rep-parada-dir { font-size: 13px; margin-top: 4px; color: #333; line-height: 1.3 }
.rep-parada-viv { font-size: 9px; font-weight: 800; letter-spacing: .08em; padding: 2px 5px; background: #111; color: #fff; border-radius: 3px; margin-left: 6px }
.rep-parada-regalo { font-size: 10px; color: #7C3AED; margin-top: 3px; font-weight: 700 }
.rep-parada-bultos {
  text-align: center; background: #1A3461; color: #fff;
  padding: 6px 10px; border-radius: 8px; min-width: 50px;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.rep-bnum { font-size: 20px; font-weight: 900; line-height: 1 }
.rep-blab { font-size: 8px; font-weight: 700; letter-spacing: .12em; margin-top: 2px }

/* ── BOTONES DE ACCIÓN agrupados (Waze + WhatsApp) ── */
.rep-parada-acciones {
  display: grid; grid-template-columns: 1fr 1fr; gap: 8px;
  margin: 12px 0;
}
.rep-btn {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  width: 100%; padding: 14px 12px;
  text-decoration: none; border: 0; cursor: pointer;
  border-radius: 10px; font-size: 13px; font-weight: 800;
  letter-spacing: .03em; text-transform: uppercase;
  transition: background .15s, transform .1s;
}
.rep-btn:active { transform: translateY(1px) }
.rep-btn:disabled { opacity: .4; cursor: not-allowed }
.rep-btn-waze { background: #33CCFF; color: #002B4D; box-shadow: 0 2px 6px rgba(51, 204, 255, .35) }
.rep-btn-waze:hover { background: #1ec0f5 }
.rep-btn-wa { background: #25D366; color: #fff; box-shadow: 0 2px 6px rgba(37, 211, 102, .35) }
.rep-btn-wa:hover { background: #20bf5b }
.rep-btn-ok {
  width: 100%; margin-top: 8px;
  background: var(--rep-pri); color: #fff;
  font-size: 14px; padding: 12px 16px;
}
.rep-btn-ok:hover { background: #15294d }

/* ── BODY: lista de entregas compactas ── */
.rep-parada-body { display: flex; flex-direction: column; gap: 8px; margin-top: 8px }

.rep-ent-row2 {
  padding: 10px 12px; background: #f8fafc; border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.rep-ent-row2.hecha { opacity: .55 }

.rep-ent-meta-row {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  font-size: 13px;
}
.rep-ent-orden {
  background: #1A3461; color: #fff;
  padding: 3px 8px; border-radius: 5px;
  font-size: 11px; font-weight: 900; letter-spacing: .03em;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.rep-ent-kit2 { font-weight: 700; color: #1A3461; flex: 1; min-width: 0 }
.rep-ent-mini-bultos {
  background: #475569; color: #fff;
  padding: 2px 7px; border-radius: 4px;
  font-size: 11px; font-weight: 800;
}
.rep-pill { padding: 3px 8px; border-radius: 999px; font-size: 10px; font-weight: 800; letter-spacing: .05em }

.rep-notas-mini {
  margin-top: 6px; padding: 6px 10px;
  background: #FEF9C3; border-left: 3px solid #EAB308;
  border-radius: 4px;
  font-size: 11px; color: #713F12;
  overflow: hidden; text-overflow: ellipsis;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  line-height: 1.35;
}

/* FAB (botón flotante) escanear QR */
.rep-fab-scan {
  position: fixed;
  bottom: 20px;
  right: 50%; transform: translateX(min(228px, 45vw));
  background: linear-gradient(135deg, #00A8B5 0%, #1A3461 100%);
  color: #fff; border: 0;
  padding: 14px 20px;
  border-radius: 999px;
  font-size: 15px; font-weight: 800; letter-spacing: .02em;
  box-shadow: 0 8px 24px rgba(0, 168, 181, .4);
  cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  z-index: 50;
}
.rep-fab-scan:active { transform: translateX(min(228px, 45vw)) scale(.96) }

/* Toast de error del scanner */
.rep-toast {
  position: fixed; bottom: 90px; left: 16px; right: 16px;
  max-width: 460px; margin: 0 auto;
  background: #FEE2E2; color: #991B1B;
  padding: 14px 16px; border-radius: 10px;
  font-size: 14px; font-weight: 600;
  border: 1.5px solid #FCA5A5;
  box-shadow: 0 4px 16px rgba(0,0,0,.15);
  z-index: 60;
}

/* Modal */
.rep-modal-bg { position: fixed; inset: 0; background: rgba(15,31,61,.5); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px }
.rep-modal { background: #fff; border-radius: 14px; padding: 20px; max-width: 420px; width: 100% }
`
